export default "__VITE_ASSET__cdb562d0__"